import Decimal from 'decimal.js';
import { useId, useMemo } from 'react';

import { sliderToValue, valueToSlider } from '../utils/sliderScale';
import styles from './Slider.module.less';

interface SliderProps {
  value: Decimal;
  min: Decimal;
  mid: Decimal;
  max: Decimal;
  onValueChange: (next: Decimal) => void;
  ariaLabel: string;
  decimals?: number;
}

const SLIDER_RESOLUTION = 1000;

export function Slider({
  value,
  min,
  mid,
  max,
  onValueChange,
  ariaLabel,
  decimals = 0,
}: SliderProps) {
  const id = useId();
  const bounds = useMemo(() => ({ min, mid, max }), [min, mid, max]);
  const t = valueToSlider(value, bounds);
  const sliderPos = Math.round(t * SLIDER_RESOLUTION);
  const fillPercent = `${(t * 100).toFixed(2)}%`;

  return (
    <div className={styles.slider} style={{ ['--slider-fill' as never]: fillPercent }}>
      <input
        id={id}
        type="range"
        min={0}
        max={SLIDER_RESOLUTION}
        value={sliderPos}
        aria-label={ariaLabel}
        onChange={e => {
          const tNext = new Decimal(e.target.value).div(SLIDER_RESOLUTION);
          const next = sliderToValue(tNext, bounds);
          onValueChange(next.toDecimalPlaces(decimals));
        }}
      />
    </div>
  );
}
